import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn, 
  FaYoutube 
} from 'react-icons/fa';
import SocialMediaModal from '../SocialMediaModal/SocialMediaModal';

import logo from "../../Images/Logo/AstraClean.png";

function Footer() {
    const [socialModalOpen, setSocialModalOpen] = useState(false);

    const handleSocialMediaClick = (e, hasLink) => {
        if (!hasLink) {
            e.preventDefault();
            setSocialModalOpen(true);
        }
    };

    const closeSocialModal = () => {
        setSocialModalOpen(false);
    };

    const footerSections = [
        {
            title: 'Company',
            links: [
                { name: 'About Us', path: '/about' },
                { name: 'Terms & Conditions', path: '/term&condition' },
                { name: 'Privacy Policy', path: '/privacypolicy' },
                { name: 'Refund Policy', path: '/refundPolicy' },
            ]
        },
        {
            title: 'For Customers',
            links: [
                { name: 'Reviews', path: '/reviews' },
                { name: 'Contact Us', path: '/contact' },
                { name: 'Help & Support', path: '/help-support' },
            ]
        },
        {
            title: 'Resources',
            links: [
                { name: 'Safety Center', path: '/safety-center' },
                { name: 'Community Guidelines', path: '/community-guidelines' },
                { name: 'Pricing Plans', path: '/pricing' },
            ]
        }
    ];

    return (
        <footer className="bg-primary text-primary-foreground pt-20 pb-10">
            <div className="container-custom">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
                    {/* Brand Section */}
                    <div className="space-y-6">
                        <Link to="/">
                            <img 
                                src={logo} 
                                alt="AstraClean" 
                                className="h-10 md:h-12 w-auto mix-blend-multiply" 
                            />
                        </Link>
                        <p className="text-primary-foreground/70 leading-relaxed max-w-xs">
                            Premium home cleaning services in Bangalore. Professional, reliable, and thorough cleaning for a healthier living space.
                        </p>
                        <div className="flex items-center gap-4">
                            <button onClick={(e) => handleSocialMediaClick(e, false)} className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all">
                                <FaInstagram />
                            </button>
                            <button onClick={(e) => handleSocialMediaClick(e, false)} className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all">
                                <FaYoutube />
                            </button>
                            <button onClick={(e) => handleSocialMediaClick(e, false)} className="w-10 h-10 rounded-full border border-primary-foreground/20 flex items-center justify-center hover:bg-accent hover:text-accent-foreground hover:border-accent transition-all">
                                <FaLinkedinIn />
                            </button>
                        </div>
                    </div>

                    {/* Navigation Links */}
                    {footerSections.map((section) => (
                        <div key={section.title}>
                            <h4 className="text-lg font-bold mb-6 text-white uppercase tracking-widest text-sm">{section.title}</h4>
                            <ul className="space-y-4">
                                {section.links.map((link) => (
                                    <li key={link.name}>
                                        <Link 
                                            to={link.path} 
                                            className="text-primary-foreground/60 hover:text-accent transition-colors duration-300"
                                        >
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom Bar */}
                <div className="pt-10 border-t border-primary-foreground/10 flex flex-col md:flex-row items-center justify-between gap-6">
                    <p className="text-primary-foreground/50 text-sm">
                        © 2026 Astra Clean Pvt Ltd. All rights reserved.
                    </p>
                    
                    <div className="flex items-center gap-6">
                        <a 
                            href="https://play.google.com/store/apps/details?id=com.cleanto.astraclean" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="bg-white/10 hover:bg-white/20 px-4 py-2 rounded-xl transition-all flex items-center gap-3 group"
                        >
                            <img
                                alt="Get it on Google Play"
                                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                className="h-8 w-auto grayscale group-hover:grayscale-0 transition-all"
                            />
                        </a>
                    </div>
                </div>
            </div>
            {socialModalOpen && <SocialMediaModal onClose={closeSocialModal} />}
        </footer>
    );
}

export default Footer;